import { withErrorBoundary } from 'react-error-boundary';
import { FindStore as FindStoreComponent } from 'modules/findStore';

function FindStore() {
    return <FindStoreComponent />;
}

export default withErrorBoundary(FindStore, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
